import React from 'react';
import { cn } from '@/lib/utils';

/** A decorative placeholder; the owning region announces its loading state. */
export function Skeleton({ as: Component = 'div', className, ...props }: React.HTMLAttributes<HTMLElement> & { as?: 'div' | 'span' }) {
  return <Component {...props} aria-hidden="true" className={cn('h-[var(--cs-dashboard-skeleton-line-height)] rounded-[var(--cs-input-radius)] bg-[var(--cs-audience-option-surface)] motion-safe:animate-pulse', className)} />;
}
